import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { shopifyGidToNumber } from "@smartrr/shared/utils/ensureShopifyGid";

import { useOrganization } from "@customer-app/account/views/OperationAquarius/utils";

import { getFormattedCustomerSupportEmail } from "../../../../utils";

export const useFormattedCustomerSupportEmail = (purchaseState: IPurchaseState) => {
  const organization = useOrganization();
  const customerShopifyId = shopifyGidToNumber(purchaseState.pmtMth.paymentMethodInternalCustomerId);
  return getFormattedCustomerSupportEmail(organization, customerShopifyId);
};
